import {QueryFunctionContext, useQuery} from '@tanstack/react-query';

import {api} from '@eksab/api';

import type {Game} from '../types';

const queryKey = (games?: Game[]) => ['games-count', games] as const;

type QueryKey = ReturnType<typeof queryKey>;

const queryFn = ({queryKey: [, games]}: QueryFunctionContext<QueryKey>) =>
  api
    .get<Record<Game, number>>('/v1/games/counts', {
      params: {
        games,
      },
    })
    .then((res) => res.data);

export const useGamesCountQuery = (games?: Game[]) =>
  useQuery({
    queryKey: queryKey(games),
    queryFn,
    enabled: !!games && games.length > 0,
  });

useGamesCountQuery.queryKey = queryKey;
useGamesCountQuery.queryFn = queryFn;
